export default "__VITE_ASSET__Cs1GjCUv__"